import React from "react";
import { Helmet } from "react-helmet";
import Behance from "../icons/socials/behance";
import Email from "../icons/socials/email";
import Facebook from "../icons/socials/facebook";
import Github from "../icons/socials/github";
import Instagram from "../icons/socials/instagram";
import Spotify from "../icons/socials/spotify";
import Tiktok from "../icons/socials/tiktok";
import Twitter from "../icons/socials/twitter";
import Verified from "../icons/socials/verified";
import Youtube from "../icons/socials/youtube";
import classes from "./View.module.css";

const View = (props) => {
  const { theme, users, background } = props;
  const userInfo = {
    _id: "639abac8975757b824636081",
    email: "umang.togadiya@nexuslinkservices.in",
    bio: "Developer",
    name: "Umang Togadiya",
    profile: "1672638747872.png",
    verified: 1,
    seoTitle: "my name is umang",
    seoDescription: "this is umang",
    analyticsCode: "my code XXXX",
    socialPosition: 1,
    showCredit: true,
  };

  const otherLinks = [
    {
      _id: "63a1b4112ca2bfee830c91d6",
      link: "https://facebook/user",
      linkType: 1,
      title: "Facebook",
      order: 0,
      subType: 1,
    },
    {
      _id: "63aa9823f69ede93009789c5",
      title: "Header 1",
      link: "",
      linkType: 1,
      subType: 2,
      order: 0,
    },
    {
      _id: "63a19bf12ca2bfee830c91d5",
      link: "https://instagram.com/umu_togadiya",
      linkType: 1,
      title: "Instagram",
      order: 1,
      subType: 1,
    },
    {
      _id: "63a1b4112ca2bfee830c91d7",
      link: "https://twitter.com/umutogadiya",
      linkType: 1,
      title: "Twitter",
      order: 1,
      subType: 1,
    },
  ];

  const socialLinks = [
    {
      _id: "63a1ae55c7b4065feb19e70b",
      title: "Instagram",
      linkType: 2,
      subType: 1,
      order: 1,
      link: "https://instagram.com/umu_togadiya",
    },
    {
      _id: "63a1ae47c7b4065feb19e708",
      title: "Facebook",
      linkType: 2,
      subType: 2,
      order: 2,
      link: "https://facebook.com/umangtogadiya",
    },
    {
      _id: "63a1ae51c7b4065feb19e70a",
      title: "Twitter",
      linkType: 2,
      subType: 3,
      order: 3,
      link: "https://twitter.com/umutogadiya",
    },
    {
      _id: "63b2c08729e75aadd8aa7fc2",
      title: "Tiktok",
      linkType: 2,
      subType: 6,
      order: 4,
      link: "https://tiktok.com/test",
    },
    {
      _id: "63b2c09129e75aadd8aa7fc3",
      title: "Spotify",
      linkType: 2,
      subType: 7,
      order: 5,
      link: "https://open.spotify.com/artist/4YRxDV8wJFPHPTeXepOstw",
    },
    {
      _id: "63a1aed4c7b4065feb19e70c",
      title: "Youtube",
      linkType: 2,
      subType: 4,
      order: 6,
      link: "https://www.youtube.com/@umu9810/videos",
    },
  ];

  const imageWithURL = () => {
    if (theme.from && theme.from === 1) {
      return "url(" + theme.themeImageMobile + ")";
    } else {
      return (
        "url(" +
        process.env.REACT_APP_IMAGE_URL +
        "theme/" +
        theme.themeImageMobile +
        ")"
      );
    }
  };

  const socialLinkComponent = () => {
    return (
      <div
        className={`mt-16 ${classes["flex-both-center"]} ${classes["flex-wrap"]}`}
      >
        {socialLinks &&
          socialLinks.map((val) => {
            return (
              <React.Fragment key={val._id}>
                <div
                  className={`${classes["relative"]} ${classes["page-social"]}`}
                >
                  <a
                    className={`${classes["social-icon-anchor"]}`}
                    target="_blank"
                    rel="noreferrer"
                    href={val.link}
                  />
                  {val.subType === 1 && <Instagram fill={theme.iconColor} />}
                  {val.subType === 2 && <Facebook fill={theme.iconColor} />}
                  {val.subType === 3 && <Twitter fill={theme.iconColor} />}
                  {val.subType === 4 && <Youtube fill={theme.iconColor} />}
                  {val.subType === 5 && <Email fill={theme.iconColor} />}
                  {val.subType === 6 && <Tiktok fill={theme.iconColor} />}
                  {val.subType === 7 && <Spotify fill={theme.iconColor} />}
                  {val.subType === 8 && <Github fill={theme.iconColor} />}
                  {val.subType === 9 && <Behance fill={theme.iconColor} />}
                </div>
              </React.Fragment>
            );
          })}
      </div>
    );
  };

  const backgroundType = () => {
    if (background === 2) {
      return {
        backgroundImage: imageWithURL(),
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }
    } else {
      return {
        background: theme.color
      }
    }
  };
  return (
    <div className="col-xl-6">
      <div className="card">
        <div className="card-header d-block">
          <div className="d-flex justify-content-between">
            <h4 className="fs-20 d-block">View</h4>
            <button className="btn btn-primary btn-sm">
              <i className="fas fa-user" /> ({users})
            </button>
          </div>
        </div>
        <div
          className={`card-body ${classes["bg-view"]}`}
          style={backgroundType()}
        >
          {background === 2 && theme.themeAnimationLink && (
            <Helmet>
              <script src={theme.themeAnimationLink} type="text/javascript" />
            </Helmet>
          )}
          <div
            className={`${classes["min-h-full"]} ${classes["flex-h-center"]}`}
            id={classes["background-div"]}
          >
            {background === 2 && theme.themeImageMobile && (
              <canvas
                id="bg-canvas"
                className="background-overlay"
                width="530"
                height="690"
                style={{ position: "absolute" }}
              ></canvas>
            )}
            <div
              className={`${classes["relative"]} ${classes["page-full-wrap"]}`}
            >
              <input type="hidden" defaultValue="creator-page" id="page-type" />
              <img
                className={`m-auto ${classes["display-image"]}`}
                src={
                  process.env.REACT_APP_IMAGE_URL +
                  "profile-images/" +
                  userInfo.profile
                }
                alt="Austin Archer"
              />
              <h1
                className={`mt-16 text-center ${classes["page-text-font"]} ${classes["page-title"]}`}
                style={{ color: theme.textColor }}
              >
                {userInfo.name}&nbsp;
                {userInfo.verified === 1 && <Verified />}
              </h1>
              <h2
                className={`mt-12 text-center ${classes["ln-h-22"]} ${classes["text-fs-16"]} ${classes["page-text-font"]} ${classes["page-bioline"]}`}
                style={{ color: theme.textColor }}
              >
                {userInfo.bio}
              </h2>
              {userInfo.socialPosition === 1 && socialLinkComponent()}
              <div className="mt-24">
                {otherLinks &&
                  otherLinks.map((val) => {
                    return (
                      <React.Fragment key={val._id}>
                        {val.subType === 1 && (
                          <div
                            className={`${classes["page-item-wrap"]} ${classes["relative"]}`}
                          >
                            <div
                              className={`${classes["absolute"]} ${classes["flex-both-center"]} ${classes["other-link"]} ${classes["page-item"]}`}
                              style={{
                                borderRadius: theme.borderRadius + "px",
                                backgroundColor: theme.linkBackgroundColor,
                              }}
                            />
                            <a
                              href={val.link}
                              className={`py-10 ${classes["flex-both-center"]} ${classes["page-item-each"]}`}
                              style={{ color: theme.textColor }}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {val.image && (
                                <img
                                  alt={val.title}
                                  src="https://cdn.bio.link/uploads/thumbnails/2022-06-26/9pXBuH72lJTeqDHG6JyxEsP8QCcPJ6EP.png"
                                  className="link-each-image"
                                />
                              )}
                              <span
                                className={`text-center ${classes["item-title"]}`}
                              >
                                {val.title}
                              </span>
                            </a>
                          </div>
                        )}
                        {val.subType === 2 && (
                          <div
                            className={`text-center mt-32 ${classes["page-item-title"]} ${classes["page-text-font"]}`}
                            style={{ color: theme.textColor }}
                          >
                            {val.title}
                          </div>
                        )}
                      </React.Fragment>
                    );
                  })}
              </div>
              {userInfo.socialPosition === 2 && socialLinkComponent()}
              {userInfo.showCredit === true && (
                <div className={`text-center ${classes["page-logo"]}`}>
                  <a
                    target="_blank"
                    aria-label="Biolink"
                    rel="noreferrer"
                    href="https://bio.link"
                  >
                    <svg
                      width={32}
                      height={32}
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        className="bl-logo-br"
                        opacity="0.5"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 0.390244C0 0.174718 0.174718 0 0.390244 0H31.6098C31.8253 0 32 0.174718 32 0.390244V31.6098C32 31.8253 31.8253 32 31.6098 32H0.390244C0.174718 32 0 31.8253 0 31.6098V0.390244ZM0.780488 0.780488V31.2195H31.2195V0.780488H0.780488ZM8.89232 9.48226V7.81313C8.89232 7.57935 8.76608 7.46247 8.51361 7.46247H7.36345V9.83291H8.51361C8.76608 9.83291 8.89232 9.71603 8.89232 9.48226ZM8.89232 13.2834V11.5441C8.89232 11.4226 8.86427 11.3384 8.80816 11.2916C8.75206 11.2355 8.65387 11.2075 8.51361 11.2075H7.36345V13.634H8.51361C8.76608 13.634 8.89232 13.5172 8.89232 13.2834ZM5.38574 6.08789H9.08869C10.2762 6.08789 10.87 6.60219 10.87 7.63078V9.20173C10.87 9.89369 10.6596 10.3285 10.2388 10.5062C10.6596 10.6651 10.87 11.0672 10.87 11.7124V13.4517C10.87 14.4896 10.2762 15.0086 9.08869 15.0086H5.38574V6.08789ZM12.0985 6.08789H14.0903V15.0086H12.0985V6.08789ZM19.0034 6.08789H17.1239C15.9363 6.08789 15.3426 6.60219 15.3426 7.63078V13.4517C15.3426 14.4896 15.9363 15.0086 17.1239 15.0086H19.0034C20.1816 15.0086 20.7707 14.4896 20.7707 13.4517V7.63078C20.7707 6.60219 20.1816 6.08789 19.0034 6.08789ZM18.765 7.91131V13.1852C18.765 13.419 18.6434 13.5359 18.4003 13.5359H17.727C17.4746 13.5359 17.3483 13.419 17.3483 13.1852V7.91131C17.3483 7.67754 17.4746 7.56065 17.727 7.56065H18.4003C18.6434 7.56065 18.765 7.67754 18.765 7.91131ZM9.95113 24.4704H7.38431V17.0225H5.39258V25.9432H9.95113V24.4704ZM12.6315 17.0225H10.6397V25.9432H12.6315V17.0225ZM17.6709 17.0225H19.5083V25.9432H17.7129L15.7633 20.5992V25.9432H13.9399V17.0225H15.7492L17.6709 22.3525V17.0225ZM24.885 21.4267L26.6803 17.0225H24.5203L22.7951 21.4267L24.5203 25.9432H26.6803L24.885 21.4267ZM20.7612 17.0225V25.9432H22.753V17.0225H20.7612ZM22.0195 13.7761C22.0195 14.4442 22.5612 14.9858 23.2293 14.9858C23.8974 14.9858 24.439 14.4442 24.439 13.7761V13.698C24.439 13.0299 23.8974 12.4883 23.2293 12.4883C22.5612 12.4883 22.0195 13.0299 22.0195 13.698V13.7761Z"
                        fill="#1F365C"
                      />
                    </svg>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default View;
